import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a4cf2e9ca334e001438e3d6_1783461214185_c6ca5ab0/instantloanmitra/src/app/referrals/page.tsx");
